import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { Router } from '@angular/router';

import { PoListViewAction } from '@po-ui/ng-components';

@Component({
  selector: 'app-sales-group',
  templateUrl: './sales-group.component.html',
  styleUrls: ['./sales-group.component.css']
})
export class SalesGroupComponent implements OnInit {
  @Output() errorEmitter = new EventEmitter();

  topTooltip: string = 'Ranking de vendas por grupo';
  topTooltipExcel: string = 'Download .xlsx';

  tableRanking = new Array();
  loading: boolean = false;
  errorApi: boolean = false;
  message: string = '';
  salesGroupParamsJson: any;
  dataTable: any;

  readonly actions: Array<PoListViewAction> = [
    {
      label: 'Detalhar',
      action: this.goToDetail.bind(this),
      icon: 'po-icon po-icon-eye'
    },
  ];

  constructor(private router: Router, private api: ApiService) { }

  ngOnInit() {
    this.api.setHeader();
    let breadcrumbLinks = [{ label: 'GESTÃO LOJA', link: '/home/sale' }, { label: 'DETALHAR', link: '/sales-group' }];
    localStorage.setItem('breadcrumbStatus', JSON.stringify(breadcrumbLinks));
    localStorage.setItem('grupoSelect', '');
    
    let salesGroupParams:any = localStorage.getItem('salesGroupParams');
    this.salesGroupParamsJson = JSON.parse(salesGroupParams);
    let objFilter = {
      dataMin: this.salesGroupParamsJson[0].dateMin,
      dataMax: this.salesGroupParamsJson[0].dateMax,
      branch: this.salesGroupParamsJson[0].branch,
      selers: this.salesGroupParamsJson[0].selers,
    }
    this.filterItem(objFilter); 
  }

  goToDetail(item: any) {
    let recoverBranchs: any = {};
    this.dataTable.map((el: any, index: any) => {
      if ((index + 1) == item['Nº']) {
        recoverBranchs = el
      }
    })
    this.changeBreadcrumbFilial(recoverBranchs['branchs'], recoverBranchs.branch_type);
  }

  changeBreadcrumbFilial(branch:any, nameBranchBreadcrumb: any) {
    localStorage.setItem('grupoSelect', nameBranchBreadcrumb);
    let salesFilialParams = [{'dateMin': this.salesGroupParamsJson[0].dateMin, 'dateMax': this.salesGroupParamsJson[0].dateMax, 'branch': branch, 'selers': this.salesGroupParamsJson[0].selers}]
    localStorage.setItem('salesFilialParams', JSON.stringify(salesFilialParams))
    this.router.navigate(['/sales-filial']);
  }


  backHome() {
    this.router.navigate(['/home/sale']);
  }

  abreviarValor(value: any) {
    if (value < 1000) {
      return 'R$ ' + value.toLocaleString('pt-br', { minimumFractionDigits: 2 });
    }
  
    if (value < 1000000) {
      return 'R$ ' + (value / 1000).toFixed(2) + 'k';
    }
  
    return 'R$ ' + (value / 1000000).toFixed(2) + 'kk';
  }

  filterItem(item: any) {
    this.errorApi = false;
    this.loading = true;
    let dataRetorno = [];
    this.dataTable = [];
    this.tableRanking = [];
    if (item.branch != undefined) {
      this.rankingMethod(item).subscribe(data => {
        try {
          let excelInfo = [];
          if (data.dataRow.length != 0) {
            dataRetorno = data.dataRow;
            this.dataTable = data.dataRow;
            dataRetorno.map((el: any, index: any) => {
              this.tableRanking.push({
                'Nº': index + 1,
                'Entidade': el.branch_type,
                'Ticket Médio': this.abreviarValor(parseFloat(el.tm)),
                'PA': parseFloat(el.pa).toFixed(2).replace("." , ","),
                'PMPV': this.abreviarValor(parseFloat(el.pmpv)),
                'Total': this.abreviarValor(parseFloat(el.invoice_value)),
              })
              excelInfo.push({
                'Nº': index + 1,
                'Entidade': el.branch_type,
                'Ticket Médio': this.abreviarValor(parseFloat(el.tm)),
                'PA': parseFloat(el.pa).toFixed(2).replace("." , ","),
                'PMPV': this.abreviarValor(parseFloat(el.pmpv)),
                'Total': this.abreviarValor(parseFloat(el.invoice_value)),
              })
            });
            this.loading = false;
            excelInfo.unshift({});
            localStorage.setItem('ranking-grupo', JSON.stringify(excelInfo));
            this.errorApi = false;
          } else {
            this.message = CONSTANTS.MESSAGES.DATA_NULL_RANKING_GRUPO;
            this.formatErrorMensagem(this.message);
            this.errorApi = true;
          }
          this.loading = false;
        } catch (error: unknown) {
          this.loading = false;
          if (error instanceof Error)
            this.formatErrorMensagem(error.message);
        }
      }, error => {
        this.loading = false;
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_ERRO_RANKING_GRUPO;
        this.formatErrorMensagem(error.message);
      })
    }
  }

  downloadExcel() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataRankingGrupo = [];
    let objectRankingGrupo = localStorage.getItem('ranking-grupo');

    objectRankingGrupo != null
      ? (dataRankingGrupo = JSON.parse(objectRankingGrupo))
      : (dataRankingGrupo = []);
    const worksheetRankingFilial= XLSX.utils.json_to_sheet(dataRankingGrupo);

    const workbook = {
      Sheets: {
        'ranking-grupo': worksheetRankingFilial,
      },
      SheetNames: [
        'ranking-grupo',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-ranking-grupo' + EXCEL_EXTENSION);
  }

  rankingMethod(item: any) {
    let classification = localStorage.getItem('filterClassification')!
    return this.api.postTotalBranchType(item.dataMin, item.dataMax, item.branch, item.selers, classification);
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: ranking-grupo \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }
}
